import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['form']

  declare readonly formTargets: HTMLFormElement[]

  merge_params (event: any): void {
    const url = event.detail.formSubmission.location

    this.formTargets
      .filter((form) => form !== event.target)
      .forEach((form) => {
        const formData = new FormData(form)

        for (const [key, value] of formData.entries()) {
          url.searchParams.set(key, value)
        }
      })
  }
}
